export const DIRECT_LINK_INTEREST_MODAL = {
  TITLE: 'Thank you for your interest',
  DESCRIPTION: 'Thank you for expressing your interest in participating in our online study.',
  DESCRIPTION_TWO: 'You can proceed to participate in the online study now. If you prefer not to participate at this time, feel free to return to your dashboard and complete the online study later.',
  BUTTONS: {
    CONFIRM: 'Proceed to Online Study',
    CANCEL: 'Back to Dashboard',
  },
};
